<div class="currency">€</div>
<div class="amount" [ngClass]="{ 'align-right': alignRight }">{{ amount | number: '1.2-2':'nl-NL' }}</div>
